import React, { memo } from 'react';
import cn from 'classnames';

import { PLAIN_GREY } from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { EVENT_Z_INDEX, MARGIN_BETWEEN_EVENTS } from '~/Screens/Calendar/constants';
import { Dots } from '~/UIKit';
import { CalendarEvent } from '~/Screens/Calendar/CalendarView/components/CalendarEvent';
import { IPositionedEvent } from '~/Screens/Calendar/interfaces';

const useStyles = makeStyles(
  () => ({
    container: {
      zIndex: EVENT_Z_INDEX,
      position: 'absolute',
      marginLeft: MARGIN_BETWEEN_EVENTS,
    },
    hasPriority: {
      zIndex: EVENT_Z_INDEX + 1,
    },
    loading: {
      zIndex: EVENT_Z_INDEX + 1,
      width: '100%',
      height: '100%',
      display: 'flex',
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
    },
    disabled: {
      color: PLAIN_GREY,
    },
  }),
  { name: 'PositionedEvent' },
);

export const PositionedEvent = memo(
  ({ event, position, isLoading, isDisabled, withTooltip, isPast, eventRef }: IPositionedEvent) => {
    const { classes } = useStyles();

    return (
      <div
        ref={eventRef}
        className={cn(classes.container, {
          [classes.disabled]: isDisabled || isLoading || isPast,
          [classes.hasPriority]: isLoading,
        })}
        style={{
          width: position.width - MARGIN_BETWEEN_EVENTS,
          height: position.height,
          transform: `translate3d(${position.left}px, ${position.top}px, 0)`,
        }}
      >
        {isLoading && (
          <div className={classes.loading}>
            <Dots />
          </div>
        )}
        <CalendarEvent event={event} withTooltip={withTooltip} />
      </div>
    );
  },
);
